import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  TextField,
  IconButton,
  Alert,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

/**
 * PageCreatedModal - Modal de sucesso após criar página
 * 
 * TODOs implementados:
 * 10.1 - Exibir URL da página criada
 * 10.2 - Botões para copiar link e abrir página
 */

const PageCreatedModal = ({
  open = false,
  slug = '',
  shortId = '',
  onClose = () => {},
  onViewPage = () => {},
}) => {
  const [copied, setCopied] = React.useState(false);

  // URL base das páginas públicas - usa variável de ambiente
  const pagesBaseUrl = import.meta.env.VITE_PAGES_URL || 'https://pages.agendario.com.br';
  const pageUrl = `${pagesBaseUrl.replace('https://', '')}/${slug}-${shortId}`;
  const fullUrl = `${pagesBaseUrl}/${slug}-${shortId}`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Erro ao copiar link:', error);
    }
  };

  const handleViewPage = () => {
    window.open(fullUrl, '_blank');
    onViewPage?.();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1,
        },
      }}
    >
      {/* Título com ícone de sucesso */}
      <DialogTitle sx={{ textAlign: 'center', pt: 3, pb: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <CheckCircleIcon sx={{ fontSize: 60, color: '#4caf50' }} />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Página Criada com Sucesso!
        </Typography>
      </DialogTitle>

      {/* Conteúdo */}
      <DialogContent sx={{ textAlign: 'center' }}>
        <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
          Sua página Link in Bio está pronta para ser compartilhada.
        </Typography>

        {/* Campo de URL */}
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            alignItems: 'center',
            mb: 3,
            p: 2,
            bgcolor: '#f5f5f5',
            borderRadius: 1,
          }}
        >
          <TextField
            value={pageUrl}
            fullWidth
            size="small"
            readOnly
            variant="outlined"
            InputProps={{
              readOnly: true,
            }}
          />
          <IconButton
            onClick={handleCopyLink}
            title="Copiar link"
            sx={{
              color: copied ? '#4caf50' : '#1976d2',
            }}
          >
            <ContentCopyIcon />
          </IconButton>
        </Box>

        {/* Mensagem de confirmação */}
        {copied && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Link copiado para a área de transferência!
          </Alert>
        )}

        {/* Informações adicionais */}
        <Box sx={{ textAlign: 'left', p: 2, bgcolor: '#f9f9f9', borderRadius: 1, mb: 3 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
            Próximos passos:
          </Typography>
          <ul style={{ margin: 0, paddingLeft: 20, fontSize: '0.875rem' }}>
            <li>Compartilhe o link em suas redes sociais</li>
            <li>Adicione à bio do seu Instagram</li>
            <li>Envie para seus clientes via WhatsApp</li>
          </ul>
        </Box>
      </DialogContent>

      {/* Ações */}
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          fullWidth
        >
          Fechar
        </Button>
        <Button
          onClick={handleViewPage}
          variant="contained"
          fullWidth
          endIcon={<OpenInNewIcon />}
        >
          Ver Página
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PageCreatedModal;
